import {Injectable} from '@angular/core';
import {UserBuying} from '../../../models/acquista-servizi-models/user-buying';

@Injectable({
  providedIn: 'root'
})
export class UserBuyingsStore {

  atLeastOneExpiringBuyingExists: boolean;
  atLeastOneNotExpiringBuyingExists: boolean;

  notExpiringUserBuyings: UserBuying[];
  expiringUserBuyings: UserBuying[];

  constructor() {
    this.notExpiringUserBuyings = new Array<UserBuying>();
    this.expiringUserBuyings = new Array<UserBuying>();
  }

  checkNotExpiringUserBuyingsNotEmpty() {
    this.atLeastOneNotExpiringBuyingExists = this.notExpiringUserBuyings.length > 0;
  }

  checkExpiringUserBuyingsNotEmpty() {
    this.atLeastOneExpiringBuyingExists = this.expiringUserBuyings.length > 0;
  }

}
